import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  async ObtenerPostPrincipal(pageIndex, pageSize, filtro) {
    var formData = new FormData();
    formData.append("pageIndex", pageIndex);
    formData.append("pageSize", pageSize);
    formData.append("filtro", filtro);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/ObtenerPostPrincipal`,
      formData
    );
    return response.data;
  },

  async ObtenerPostInfo(baclave) {
    var formData = new FormData();
    formData.append("baclave", baclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/ObtenerPostInfo`,
      formData
    );
    return response.data;
  },

  async ObtenerCategorias() {
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/ObtenerCategorias`
    );
    return response.data;
  },

  async ObtenerCategoriasTodas() {
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/ObtenerCategoriasTodas`
    );
    return response.data;
  },

  async ObtenerTotalArticulos() {
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/ObtenerTotalArticulos`
    );
    return response.data;
  },

  async LikeBlogPost(baclave) {
    var formData = new FormData();
    formData.append("baclave", baclave);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/LikeBlogPost`,
      formData
    );
    return response.data;
  },

  async PublicarArticuloNuevo(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/PublicarArticuloNuevo`,
      data
    );
    return response.data;
  },

  async PublicarBorrador(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/PublicarBorrador`,
      data
    );
    return response.data;
  },

  async ObtenerImagenBlogSingle(route) {
    var formData = new FormData();
    formData.append("fileRoute", route);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/ObtenerImagenBlogSingle`,
      formData
    );
    return response.data;
  },

  async BlogAgregarCategoria(category) {
    var formData = new FormData();
    formData.append("nombre", category);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/BlogAgregarCategoria`,
      formData
    );
    return response.data;
  },

  async BlogEliminarCategoria(bcclaves) {
    var formData = new FormData();
    formData.append("bcclave", bcclaves);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/BlogEliminarCategoria`,
      formData
    );
    return response.data;
  },

  async CambiarEstatusArticulo(baclave, status) {
    var formData = new FormData();
    formData.append("baclave", baclave);
    formData.append("newStatus", status);
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/CambiarEstatusArticulo`,
      formData
    );
    return response.data;
  },

  async EditarArticuloPublicado(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}Blog/EditarArticuloPublicado`,
      data
    );
    return response.data;
  },
};
